import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "33",
  height: "33",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "13.833",
      cy: "9.456",
      r: "5.333",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("ellipse", {
      cx: "13.833",
      cy: "24.122",
      fill: "currentColor",
      opacity: ".5",
      rx: "9.333",
      ry: "5.333"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M24.974 3.609a1 1 0 0 1 1.371-.343l-.514.857.514-.857h.002l.002.002.005.003.013.008a3 3 0 0 1 .152.101c.094.066.22.16.369.283.296.247.683.616 1.069 1.117.777 1.01 1.54 2.553 1.54 4.677s-.763 3.666-1.54 4.676c-.386.501-.773.87-1.07 1.117a6 6 0 0 1-.52.384l-.013.008-.005.003-.002.001s-.002.001-.516-.856l.514.857a1 1 0 0 1-1.034-1.711l.007-.005.054-.036c.052-.037.134-.097.235-.182.204-.17.484-.434.765-.8.556-.723 1.126-1.847 1.126-3.456 0-1.61-.57-2.734-1.126-3.457a5 5 0 0 0-.765-.8 4 4 0 0 0-.29-.218l-.006-.005a1 1 0 0 1-.337-1.368",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M22.27 6.343a1 1 0 0 1 1.342-.448l-.448.895.447-.895.003.002h.002l.005.003.011.006.03.016.079.046q.093.056.232.157c.18.136.411.34.639.624.465.58.886 1.465.886 2.708 0 1.242-.421 2.126-.886 2.708a3.6 3.6 0 0 1-.64.623 3 3 0 0 1-.31.203l-.03.016-.011.006-.005.002-.002.002s-.003 0-.441-.877l.439.878a1 1 0 0 1-.91-1.782l.07-.048c.07-.052.172-.14.278-.273.202-.252.448-.701.448-1.458 0-.758-.246-1.207-.448-1.46a1.6 1.6 0 0 0-.347-.32l-.004-.002a1 1 0 0 1-.43-1.332",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }